import { TableColumnModel } from '../tableColumsModel';
const IdColumn = new TableColumnModel('id', 'Id', 170, true, false);
const NameColumn = new TableColumnModel('name', 'Name', 170, true, false);

export const TopicsTableColumns = () => {
  return [IdColumn, NameColumn];
};
